export default __webpack_public_path__ + "fe98ce1cb54f4548a6ba3a657cf79a30.png";